import { mdiAccountMultiple, mdiHistory, mdiWidgets, mdiTune, mdiPuzzle } from "@mdi/js";

import i18n from "./lang";

export default [
	i18n.global.t("panel.common.menu"),
	[
		{
			to: "/widgets",
			label: i18n.global.t("panel.widget.title"),
			icon: mdiWidgets,
			updateMark: true,
		},
		{
			to: "/users",
			label: i18n.global.t("panel.common.users"),
			icon: mdiAccountMultiple,
			updateMark: true,
		},
	{
		to: "/widgets/system-settings",
		label: i18n.global.t("panel.widget.system.menu"),
		icon: mdiTune,
		updateMark: true,
	},
	{
		to: "/widgets/plugins",
		label: i18n.global.t("panel.widget.plugins.menu"),
		icon: mdiPuzzle,
		updateMark: true,
	},
	{
		to: "/widgets/sessions",
		label: i18n.global.t("panel.widget.sessions.title"),
		icon: mdiHistory,
		updateMark: true,
		},

	],
];
